import apiFor from './apiInterceptor';
const api = apiFor('/accountingService'); // meaningful backend name

const API_URIS = {
	factures: process.env.REACT_APP_FACTURATIONS_API_URI,
	facture_lines: process.env.REACT_APP_FACTURATIONS_LINES_API_URI,
	accounts: process.env.REACT_APP_ACCOUNTS_API_URI,
	taxes: process.env.REACT_APP_TAXES_API_URI,
	journaux: process.env.REACT_APP_JOURNAL_API_URI,
	paiements: process.env.REACT_APP_PAIEMENTS_API_URI,
	ecritures: process.env.REACT_APP_ECRITURES_API_URI,
	charges: process.env.REACT_APP_CHARGES_API_URI,
	init: '/initialize-app',
	paiements_move: '/account_payment_move',
	bilan: "/bilanfactures"
};

// --- GET ALL ---
export const getAll = async (type, fncSuccess, page = 0, limit = 0) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = `${API_URIS[type]}?page=${page}&limit=${limit}`;

	try {
		const res = await api.get(url);
		fncSuccess(res.data || []);
		return res.data;
	} catch (error) {
		console.log(error);
		return null;
	}
};

// --- GET API ---
export const getAPI = async (type, fnSuccess = () => { }, fnError = () => { }, signal = null) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = API_URIS[type];

	try {
		const res = await api.get(url, { signal });
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`GET ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// --- GET API BY ID ---
export const getAPIById = async (
	type,
	id,
	fnSuccess = () => { },
	fnError = () => { },
	signal = null,
) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = `${API_URIS[type]}/${id}`;

	try {
		const res = await api.get(url, { signal });
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`GET ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// --- SEARCH PYTHON API ---
export const searchPythonAPI = async (
	type,
	filters,
	page = 1,
	limit = 0,
	fnSuccess = () => { },
	fnError = () => { },
	signal = null,
) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);

	const queryParams = new URLSearchParams({
		page: page.toString(),
		limit: limit.toString(),
		data: JSON.stringify(filters),
	});
	const url = `/search${API_URIS[type]}?${queryParams.toString()}`;

	try {
		const res = await api.get(url, { signal });
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`SEARCH ${url} error:`, error.response?.data || error.message);
		return null;
	}
};



// --- CREATE API ---
export const createAPI = async (type, newData, fnSuccess = () => { }, fnError = () => { }) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = API_URIS[type];

	try {
		const res = await api.post(url, newData);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`POST ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// --- UPDATE API ---
export const updateAPI = async (type, id, newData, fnSuccess = () => { }, fnError = () => { }) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = `${API_URIS[type]}/${id}`;

	try {
		const res = await api.put(url, newData);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`PUT ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// --- DELETE PYTHON API ---
export const deletePythonAPI = async (type, id, fnSuccess = () => { }, fnError = () => { }) => {
	if (!API_URIS[type]) throw new Error(`Invalid API type: ${type}`);
	const url = `${API_URIS[type]}/${id}`;

	try {
		const res = await api.delete(url);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`DELETE ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// --- FILE UPLOAD ---
export const handleFileUpload = async (file, addedUrl) => {
	const formData = new FormData();
	formData.append('attachments', file);

	try {
		const url = `/upload${addedUrl}`;
		const res = await api.post(url, formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		return res.data;
	} catch (error) {
		console.log('File upload error:', error);
		return null;
	}
};

// --- COMPTABILISER (PUT) ---
export const comptabiliserAPI = async (id, newData, fnSuccess = () => { }, fnError = () => { }) => {
	if (!id) throw new Error('Missing ID for comptabiliserAPI');
	const url = `/comptabilise/${id}`;

	try {
		const res = await api.put(url, newData);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`PUT ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// --- COMPTABILISER COMMANDE (POST) ---
export const comptabiliserCommandeAPI = async (
	newData,
	fnSuccess = () => { },
	fnError = () => { },
) => {
	const url = `/cmd/comptabilise`;

	try {
		const res = await api.post(url, newData);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`POST ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

/** Paiement  */

export const paiementAPI = async (newData, fnSuccess = () => { }, fnError = () => { }) => {
	const url = `/post/paiement`;

	try {
		const res = await api.post(url, newData);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`POST ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

export const updatePaiementAPI = async (id, newData) => {
	const url = `/update/paiement/${id}`;

	try {
		const res = await api.put(url, newData);
		return res.data;
	} catch (error) {
		console.log(`POST ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

export const comptabiliserPaiementAPI = async (id, fnSuccess = () => { }, fnError = () => { }) => {
	if (!id) throw new Error('Missing ID for comptabiliserAPI');
	const url = `/comptabilisePaiement/${id}`;

	try {
		const res = await api.put(url, {});
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`PUT ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

export const createFactureAPI = async (data) => {
	const url = '/facture/create';

	try {
		const res = await api.post(url, data);
		return res.data;
	} catch (error) {
		console.log(`PUT ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

// ----------------------------------------------------------------------
// --- NOUVELLES FONCTIONS DE GESTION DES ATTACHEMENTS (VOLUMES) ---
// ----------------------------------------------------------------------

// 1. Récupérer la liste des attachements pour un enregistrement (si API existe)
export const getAllAttchmentsAPI = async (module, record_id) => {
	const url = `/volumes/list`; // Assurez-vous que cette route existe dans votre backend

	try {
		const response = await api.get(url, {
			params: { module, record_id },
		});
		// La structure de la réponse dépend de votre backend Flask
		return response?.data;
	} catch (error) {
		console.log('Erreur lors de la récupération de la liste des attachements:', error);
		return null;
	}
};

// 2. Construire l'URL d'accès à un seul attachement
// NOTE: Cette fonction retourne juste la chaîne de caractères URL, elle ne fait pas d'appel HTTP
export const getSingleAttachementAPI = (module, id, filename) => {
	// Utilise le BASIC_API_URL pour construire le chemin complet d'accès au fichier
	return `/accountingService/uploads/${module}/${id}/${filename}`;
};

export const uploadAttachmentAPI = async (formData) => {
	try {
		// Assurez-vous que formData contient les champs 'module', 'record_id' et 'attachments'
		const url = `/volumes/upload`;

		const res = await api.post(url, formData, {
			headers: {
				// Le Content-Type n'est généralement PAS requis pour Axios/FormData
				'Content-Type': 'multipart/form-data',
			},
		});

		if (res.status !== 200) {
			throw new Error('Échec de la mise à jour du paiement');
		}
		return res.data;
	} catch (error) {
		console.log('Erreur lors du téléchargement du fichier:', error);
		return null;
	}
};

// 3. Supprimer un attachement spécifique
export const deleteAttachmentAPI = async (module, record_id, filename) => {
	try {
		const url = `/volumes/delete`;

		const res = await api.delete(url, {
			data: { module, record_id, filename },
		});

		if (res.status !== 200) {
			throw new Error('Échec de la suppression du fichier');
		}

		return res.data;
	} catch (error) {
		console.log('Erreur lors de la suppression du fichier:', error);
		throw error;
	}
};

export const getBilanFactures = async (
	filters,
	fnSuccess = () => { },
	fnError = () => { },
	signal = null,
) => {

	const queryParams = new URLSearchParams(filters);

	const url = `/bilanfactures?${queryParams.toString()}`;

	try {
		const res = await api.get(url, { signal });
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`SEARCH ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

export const updateRelanceCounter = async (
	recordId, channel, action,
	fnSuccess = () => { },
	fnError = () => { },

) => {
	const url = `/facture/relance/${recordId}/${channel}/${action}`;

	try {
		const res = await api.get(url);
		fnSuccess(res.data);
		return res.data;
	} catch (error) {
		fnError(error);
		console.log(`SEARCH ${url} error:`, error.response?.data || error.message);
		return null;
	}
};

